import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Router} from '@angular/router';

import { environment } from '../../../../environments/environment';
import {AuthService} from '../../../services/auth/auth.service';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.css']
})
export class ResetPassComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
  credentialsForm: FormGroup;
    visibleSpinner = false;
    usuario: string;
    regExpCorreo: string = environment.regExpCorreo;
    nombreSistema: string = environment.nombreSistema;

    // Variables para mensaje
    code: any;
    titulo: any;
    detalle: any;

    constructor(private formBuilder: FormBuilder, private router: Router, private authService: AuthService) {
    }

    ngOnInit(): void {
        this.credentialsForm = this.formBuilder.group({
          correo: ['', [Validators.required, Validators.pattern(this.regExpCorreo)]]
        });

        document.getElementById('correo').focus();
    }

    solicitarCambioPass() {
        this.visibleSpinner = true;
        this.authService.reiniciarPass(this.credentialsForm.value.correo)
            .subscribe((res: any) => {
                console.log('res reset pass ', res);
                this.visibleSpinner = false;

                if (res.success) {
                    this.code = 'reset_pass.success.default';
                    setTimeout(() => {
                      this.router.navigate(['auth/login']);
                    }, 1000);
                } else {
                    let errores = '';

                    if (res.data.message === 'Ver errores en extras') {
                        if (res.data.extra.length > 1) {
                            errores += '<ul>';
                            errores += '<li>' + res.data.extra.join('</li><li>') + '</li>';
                            errores += '</ul>';
                        } else {
                            errores = res.data.extra[0];
                        }
                    } else {
                        errores = res.data.message;
                    }
                    this.code = 'reset_pass.warn.default';
                    this.detalle = errores;
                }
            }, error => {
                console.log('Error ', error);
                this.visibleSpinner = false;
                this.code = 'reset_pass.error.default';
                this.detalle = error;
            });
    }

}
